import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

export const ExpertReviewSkeleton = styled.div`
  display: flex;
  align-items: center;
  gap: calc(
    ${({ theme }) => ThemeSelectors.getRelatedTwoSpacing(theme)} +
      ${({ theme }) => ThemeSelectors.getGroupThreeSpacing(theme)}
  );
  margin-bottom: ${({ theme }) => ThemeSelectors.getRelatedOneSpacing(theme)};

  @media (max-width: 900px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const ExpertReviewColumn = styled.div`
  flex: 1;
  width: 100%;
`;
